// extracted by mini-css-extract-plugin
module.exports = {"listItemUl":"BulletListItem_listItemUl__UCQuC typography_body__vVxn5"};